import { render, staticRenderFns } from "./passwordModal.vue?vue&type=template&id=246d9db4&scoped=true&"
import script from "./passwordModal.vue?vue&type=script&lang=ts&"
export * from "./passwordModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246d9db4",
  null
  
)

export default component.exports